import styles from './TaxonomyTerms.module.scss'

export default function TaxonomyTerms({ post, taxonomy, className }) {
  const terms = post?.[taxonomy]?.edges.map((edge) => edge.node.name).filter(Boolean)

  if (!terms?.length) {
    return null
  }

  return (
    <div>
      <span className={`${styles.termLinks} ${className || ''}`}>{terms.join(', ')}</span>
    </div>
  )
}
